<script>
  export let value = 0;
  export let isClicked = false;
  export let handleMouseDown = () => {};

  export let placeholder = "";
  export let max = undefined;
  export let min = undefined;
  export let buttonText = "";

  let isOutOfRange = false;

  $: {
    const belowMin = min !== undefined && value < min;
    const aboveMax = max !== undefined && value > max;
    isOutOfRange = belowMin || aboveMax;
  }

  function mouseDown() {
    if (!isOutOfRange) {
      isClicked = true;
      handleMouseDown();
    }
  }

  function handleMouseUp() {
    isClicked = false;
  }

  function handleMouseLeave() {
    isClicked = false;
  }
</script>

<div>
  <div class="input_wrapper">
    <div
      type="button"
      class="group_button {isClicked ? 'clicked' : ''} {isOutOfRange
        ? 'disabled'
        : ''}"
      on:mousedown={mouseDown}
      on:mouseup={handleMouseUp}
      on:mouseleave={handleMouseLeave}
    >
      {buttonText}
    </div>
    <div class="buttons_wrapper number_selector">
      <div class="container">
        <div>
          <input type="number" {placeholder} bind:value {max} {min} />
        </div>
      </div>
    </div>
  </div>
  {#if isOutOfRange}
    <div class="error_message">
      Value must be
      {#if min !== undefined}
        ≥ {min}{/if}
      {#if min !== undefined && max !== undefined}
        and
      {/if}
      {#if max !== undefined}
        ≤ {max}{/if}
    </div>
  {/if}
</div>

<style>
  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .number_selector {
    display: flex;
    align-items: center;
    height: 3rem;
    margin-left: 0.3rem;
  }

  .input_wrapper {
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    padding: 0 0.3rem 0 0.3rem;
  }

  input {
    border: none;
    padding: 0 0.5rem;
    height: auto;
    width: 4rem;
  }

  .group_button {
    height: 2.4rem;
    width: fit-content;
    display: flex;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    transition: 100ms ease-in-out;
    user-select: none;
  }

  .group_button:hover {
    background-color: var(--pax-white);
    color: var(--pax-black);
  }

  .clicked:hover {
    border-color: white;
    color: var(--pax-grey);
    border-bottom: inset;
    border-top: groove;
  }

  input:focus {
    outline: none;
  }

  .container {
    background-color: var(--pax-white);
    color: var(--pax-black);
    border-radius: 0.5rem;
    align-items: center;
    display: flex;
    gap: 0.5rem;
    height: 2.4rem;
    padding: 0 0.3rem;
  }

  .group_button.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .error_message {
    color: var(--pax-red, red);
    font-size: 0.75rem;
    margin-left: 0.5rem;
    margin-top: 0.25rem;
  }
</style>
